<template>
	<div class="problemorder">
		<el-dialog
		  :title="$t('other.a808')"
		  size="mini"
		  :visible.sync="returnInfo88"
		  width="60%"
		 >
		 <div class="logistics-header">
			 {{$t('other.a821')}}：
		   <el-select class="order-selec" v-if="userPos === 'STORE'"  size="mini" v-model="store"  :placeholder="$t('other.a809')" >
			<el-option
			  v-for="item in allstore"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value"
			  default-first-option
			  
			  >
			</el-option>
		   </el-select>
		 </div>
		 <div style="margin-bottom: 15px;">
			 <el-upload
			   class="upload-demo"
			   drag
			   action="https://jsonplaceholder.typicode.com/posts/"
			   multiple>
			   <i class="el-icon-upload"></i>
			   <div class="el-upload__text">{{$t('other.a822')}}<em>{{$t('other.a368')}}</em></div>
			   <div class="el-upload__tip" slot="tip">{{$t('other.a103')}}</div>
			 </el-upload>
		 </div>
		 <div>
			 <el-input
			   type="textarea"
			   :placeholder="$t('other.a810')"
			   v-model="textarea"
			   maxlength="120"
			   show-word-limit
			 >
			 </el-input>
		 </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="returnInfo = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="comfirm">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		
		
		<!-- 查看退货包裹 -->
		<el-dialog
		  :title="$t('other.a811')"
		  :visible.sync="returnbag"
		  width="60%"
		  >
		  <div class="returnbag-box">
			  
			  <div>
				  <div v-if="!returnImag.length">{{$t('other.a823')}}</div>
				  <div style="display: flex;" v-else>
					  <div   style="width:80px;height: 80px;padding: 0 5px;"
					  v-for="item in returnImag">
					  		<img v-image-preview style="width: 100%;" :src="item.imageUrl">
					  </div>
				  </div>
			  </div>
			   <el-table
			        :data="viewReturnDescData.items"
			        style="width: 100%"
					height="150px"
					>
			        <el-table-column
			          prop="date"
			          :label="$t('other.a66')"
			          width="60">
					  <template slot-scope="scope">
					  		<img v-image-preview :src="scope.row.image" alt="" style="width: 50px;height: 50px">
					  </template>
			        </el-table-column>
			        <el-table-column
			          prop="itemName"
			          :label="$t('other.a30')"
					  :show-overflow-tooltip="true"
			          width="180">
			        </el-table-column>
					<el-table-column
					  :show-overflow-tooltip="true"
					  label="sku"
					  width="150">
					  <template slot-scope="scope">
					  		<span>{{scope.row.itemSku}}</span>
					  </template>
					</el-table-column>
			        <el-table-column
			        
					  :show-overflow-tooltip="true"
					  width="120"
			          :label="$t('other.a812')">
					  <template slot-scope="scope">
					  		<span>{{auditType(scope.row.storeReturnType)}}</span>
					  </template>
			        </el-table-column>
					<el-table-column
					  prop="storeReturnNum"
					  :show-overflow-tooltip="true"
					  width="120"
					  :label="$t('other.a813')">
					</el-table-column>
			      </el-table>
				  <div>
					  <p style="padding:5px 0;color:red" v-if="viewReturnDescData.returnMessage">{{$t('other.a579')}}：{{viewReturnDescData.returnMessage}}</p>
					  <p style="padding:5px 0;color:red" v-if="viewReturnDescData.sellerMessage">{{$t('other.a499')}}：{{viewReturnDescData.sellerMessage}}</p>
					  <p style="padding:5px 0;color:red" v-if="viewReturnDescData.storeMessage">{{$t('other.a579')}}：{{viewReturnDescData.storeMessage}}</p>
				  </div>
			  
		  </div>
		    <div style="text-align: right;">
				<el-button type="primary" @click="returnbag = false">{{$t('other.a729')}}</el-button>
			</div>
		    
		 
		</el-dialog>
		
		<el-dialog
		  :title="$t('other.a85')"
		  size="mini"
		  :visible.sync="LogisticsWindow"
		  width="60%"
		 >
		 <div class="logistics-header">
			   <div>{{$t('other.a86')}}{{LogisticsInfo.tracking_number}}</div>
				<div>{{$t('other.a87')}}{{LogisticsInfo.order_sn}}</div>
		 </div>
		 <div class="logistics-header">{{$t('other.a824')}}：{{returnCause(LogisticsInfo.logistics_status)}}</div>
		  <el-table
		       :data="LogisticsInfo.tracking_info"
		       height="250px"
			   >
		       <el-table-column
			   :label="$t('other.a89')"
		         width="200">
				 <template slot-scope="scope">
				 	{{getLocalTime(scope.row.update_time)}}
				 </template>
		       </el-table-column>
		       <el-table-column
			   :label="$t('other.a90')"
		         width="600">
				 <template slot-scope="scope">
				 	{{scope.row.description}}
				 </template>
		       </el-table-column>
		 
		   </el-table>
		   
		  
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="LogisticsWindow = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="LogisticsWindow = false">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		
		<el-dialog
		   class="el_dialog"
		  :title="$t('other.a814')"
		  :visible.sync="dialogVisible_returnorder"
		  width="600px"
		  >
		  <div class="return_desc">
			  <div v-for="(item,index) in return_desc_order">
				  <div class="return_desc_item price">
				  	  {{$t('other.a825')}}：{{item.refundAmount}}({{item.currency}})
				  </div>
				<div class="return_desc_item">{{$t('other.a55')}}：{{getStatus(item)}}</div>
				<div class="return_desc_item order">
					<span class="order-ppo">{{$t('other.a826')}}{{$t('other.a86')}}{{item.trackingNumber}}</span>
				  <span class="order-ppo">{{$t('other.a87')}} {{item.ordersn}}</span>
				  
				</div>
				  <div class="return_desc_item order">
					  <span class="order-ppo">{{$t('other.a827')}}：{{item.username}}</span>
					  <span class="order-ppo">{{$t('other.a828')}}： {{item.email}}</span>
				  </div>
				  <div class="return_desc_item">{{$t('other.a829')}}：{{getTime(item.returnShipDueDate)}}</div>
				  <div class="return_desc_item">{{$t('other.a830')}}：{{getTime(item.returnSellerDueDate)}}</div>
				  <div class="return_desc_item">
				  	  {{$t('other.a830')}}：{{getCancelByreason(item.reason)}}
				  </div>
				  <div class="return_desc_item">
					  <span class="return-desc-pic-item" v-for="p in orderReturndesc(item.images)">
						  <span class="return-desc-pic-box">
							 <img v-image-preview :src="changeImgURL(p)" >								
						  </span>
					  </span>
				  	  
				  </div>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible_returnorder = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="dialogVisible_returnorder = false">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<!-- //发货仓弹窗 -->
		<el-dialog
		  :title="$t('other.a651')"
		  :visible.sync="dialogVisible01"
		  width="30%"
		  >
		  <el-select class="country-choose" v-model="warehouseValue" :placeholder="$t('other.a651')">
		      <el-option
		        v-for="item in warehouselist"
		        :key="item.value"
		        :label="item.label"
		        :value="item.value">
		      </el-option>
		    </el-select>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible01 = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="Review()">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 卖家确认退货操作类型: -->
		<el-dialog
		  :title="$t('other.a816')"
		  size="mini"
		  :visible.sync="returnInfo"
		  width="60%"
		 >
		 <div v-if="type === 30 && userPos === 'SELLER'" class="retrun-reasonr sellerMessage">
		 	<div>{{$t('other.a579')}}：{{returnStur.returnMessage}}</div>
		 </div>
		 <div v-if="type === 31  " class="retrun-reasonr sellerMessage">
		 	<div>{{$t('other.a499')}}：{{returnStur.sellerMessage}}</div>
		 </div>
		 <div style="margin-bottom: 20px;">
			    <el-table
			       :data="returnStur.items"
				   height="300px"
			       style="width: 100%">
				   <el-table-column
				   v-if="userPos ==='STORE'"
				     :label="$t('other.a812')"
				     width="100"
					 :show-overflow-tooltip="true"
					 >
					 
					 <template slot-scope="scope">
					 	<span style="color: red;">{{auditType(scope.row.sellerReturnType)}}</span>
					 </template>
				   </el-table-column>
				   <el-table-column
				     :label="$t('other.a66')"
				     width="80" 
					 >
					 <template slot-scope="scope">
						 <img v-image-preview style="width: 60px;height: 60px;" :src="changeImgURL(scope.row.image)"  />
					 </template>
				   </el-table-column>
			       <el-table-column
			         prop="itemName"
			         :label="$t('other.a817')"
			         width="180"
					 :show-overflow-tooltip="true"
					 >
			       </el-table-column>
			       <el-table-column
			         prop="itemSku"
			         label="SKU"
					  :show-overflow-tooltip="true"
			         width="120">
			       </el-table-column>
				   <el-table-column
				    
				     :label="$t('other.a813')"
					  :show-overflow-tooltip="true"
				     width="120">
					 <template slot-scope="scope" >
					 		<el-input v-if="scope.row.sellerReturnType === 2" style="width: 60px;"   size="mini"  type="number" onkeyup="value=value.replace(/[^\d]/g,'')"   v-model="scope.row.sellerReturnNum"  :placeholder="$t('other.a818')" />
					 </template>
				   </el-table-column>
				   <el-table-column
				    
				     :label="$t('other.a33')"
				     width="180"
					 :show-overflow-tooltip="true"
					 >
					 <template  slot-scope="scope">
						<el-radio-group v-if="userPos === 'SELLER'" style="display: flex;flex-direction: column;" size="mini" v-model="scope.row.sellerReturnType">
							<div style="display: flex;">
								<el-radio style="margin-bottom:20px" size="mini" :label='2'>{{$t('other.a806')}}</el-radio>
								
							</div>
						  <el-radio style="margin-bottom:20px" size="mini" :label='1'>{{$t('other.a805')}}</el-radio>
						 <el-radio style="margin-bottom:20px" size="mini" :label='3'>{{$t('other.a807')}}</el-radio>
						</el-radio-group> 
						
					 </template>
				   </el-table-column>
			     </el-table>
		
		 </div>
		 <div>
			 <el-input
			 v-if="userPos ==='SELLER'"
			   type="textarea"
			   :placeholder="$t('other.a819')"
			   v-model="textarea"
			   maxlength="120"
			   show-word-limit
			 >
			 </el-input>
			 <el-input
			 v-if="userPos ==='STORE'"
			   type="textarea"
			   :placeholder="$t('other.a820')"
			   v-model="textarea"
			   maxlength="120"
			   show-word-limit
			 >
			 </el-input>
			 
		 </div>
		 
		  
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="returnInfo = false">{{$t('other.a106')}}</el-button>
		    <el-button v-if="userPos === 'SELLER'" type="primary" @click="comfirm">{{$t('other.a279')}}</el-button>
			<el-button v-if="userPos === 'STORE'" type="primary" @click="StoreComfirm">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<div >
			<div class="order-title" @click="accp()">{{$t('problemorder.title')}}</div>
		    <el-tabs v-model="activeName" @tab-click="handleClick">
		       <el-tab-pane label="shopee" name="first">
				   <div>
					  <el-select size="mini" v-model="shopeeIdvlue" placeholder="shopeeId[0].label"  @change="changebtn()">
					      <el-option
					        v-for="item in shopeeId"
					        :key="item.value"
					        :label="item.label"
					        :value="item.value"
					  	  default-first-option
					  	  >
					      </el-option>
					    </el-select>
				   </div>
				   <!-- 第一行菜单栏 -->
				   <div class="order-query">
				   	<div>
				   		<el-button size="mini" :type="isIndex=== 30 ?'primary' :''" class="query-order-item" v-if="userPos === 'STORE' "   @click="changebtn_STORE(30)">{{$t('problemorder.tap_tuhuobaoguo')}}({{management01}})</el-button>
				   		<el-button size="mini" :type="isIndex=== 31 ?'primary' :''" class="query-order-item" v-if="userPos === 'STORE' "   @click="changebtn(31)">{{$t('problemorder.tap_maijiaqueren')}}({{management02}})</el-button>
				   		<el-button size="mini" :type="isIndex=== 32 ?'primary' :''" class="query-order-item" v-if="userPos === 'STORE' "   @click="changebtn(32)">{{$t('problemorder.tap_audited')}}({{management03}})</el-button>
				   		<el-button size="mini" :type="isIndex=== 13 || isIndex=== 24 || isIndex=== 25 || isIndex=== 26 || isIndex=== 27 || isIndex=== 28 || isIndex=== 29 ?'primary' :''" class="query-order-item" v-if="userPos === 'SELLER' "  @click="changebtn(13)" height="30px">{{$t('problemorder.tap_canceled')}}({{canceldingdang}})</el-button>
				   		<el-button size="mini" :type="isIndex=== 14 || isIndex=== 15 || isIndex=== 16 || isIndex=== 17 || isIndex=== 18 || isIndex=== 19 || isIndex=== 21 || isIndex=== 22 || isIndex=== 23?'primary' :''" class="query-order-item" v-if="userPos === 'SELLER' "  @click="changebtn(14)">{{$t('problemorder.tap_return')}}({{tuhuodingdang}})</el-button>
				   		<el-button size="mini" :type="isIndex=== 10 ?'primary' :''" class="query-order-item" v-if="userPos === 'SELLER' "  @click="changebtn(10)">{{$t('problemorder.tap_in_cancel')}}({{senqingquxiao}})</el-button>
				   	</div>
					
				   	<div class="second-menu">
				   		<div v-if="type === 14 || userPos === 'STORE'" class="second-menu-left">
				   			<el-input
				   			 class="sousuo-box"
				   			 size="mini"
				   			  :placeholder="$t('problemorder.return_trickNO')"
				   			  v-model="input10"
				   			  clearable>
				   			</el-input>
				   			<el-button size="mini" class="search-box" type="primary" icon="el-icon-search" @click='gotosearch01'>{{$t('problemorder.search')}}</el-button>
				   		</div>
				   		<div v-else  class="second-menu-left">
				   			<el-input
				   			 class="sousuo-box"
				   			 size="mini"
				   			  :placeholder="$t('problemorder.search_tip')"
				   			  v-model="input10"
				   			  clearable>
				   			</el-input>
				   			<el-button size="mini" class="search-box" type="primary" icon="el-icon-search" @click='gotosearch'>{{$t('problemorder.search')}}</el-button>
				   		</div>
				   	</div>
				   </div>
				   
				   	<!-- 第二行菜单栏 -->
				   <div class="order-quert-retuen" v-if="type === 14 || type === 15 || type === 16 || type ===17 || type === 18|| type === 19  || type === 22 || type === 21 || type === 23">
				   	<el-button :type="isIndex=== 15 ?'primary' :''"  class="order-quert-retuen-item"  @click="changebtn(15)">{{$t('problemorder.tap_in_cancel01')}}({{applicationCounts}})</el-button>
				   	<el-button :type="isIndex=== 16 ?'primary' :''"  class="order-quert-retuen-item" @click="changebtn(16)">{{$t('problemorder.tap_alerdy_return')}}({{acceptedCounts}})</el-button>
				   	<el-button :type="isIndex=== 17 ?'primary' :''"  class="order-quert-retuen-item" @click="changebtn(17)">{{$t('problemorder.tap_cancel_return')}}({{cancelCounts}})</el-button>
				   	<el-button :type="isIndex=== 19 ?'primary' :''"  class="order-quert-retuen-item" @click="changebtn(19)">{{$t('problemorder.tap_in_return')}}({{returnCounts}})</el-button>
				   	<el-button :type="isIndex=== 23 ?'primary' :''"  class="order-quert-retuen-item" @click="changebtn(23)">{{$t('problemorder.tap_dispute')}}({{rulingCounts}})</el-button>
				   	<el-button :type="isIndex=== 18 ?'primary' :''"  class="order-quert-retuen-item" @click="changebtn(18)">{{$t('problemorder.tap_ruling')}}({{disputeCounts}})</el-button>
				   	<el-button :type="isIndex=== 22 ?'primary' :''"  class="order-quert-retuen-item" @click="changebtn(22)">{{$t('problemorder.tap_returned_money')}}({{returnedCounts}})</el-button>
				   	<el-button :type="isIndex=== 21 ?'primary' :''"  class="order-quert-retuen-item" @click="changebtn(21)">{{$t('problemorder.tap_close')}}({{closedCounts}})</el-button>
				   </div>
				   
				   <div class="order-quert-retuen" v-if="userPos === 'SELLER' && type === 13 || type === 24 || type === 25 || type === 26 || type === 27 || type === 28 || type === 29">
				   	<el-button :type="isIndex=== 24 ?'primary' :''" class="order-quert-retuen-item"  @click="changebtn(24)">{{$t('problemorder.tap_delivery_failed')}}({{deliverfailedCount}})</el-button>
				   	<el-button :type="isIndex=== 25 ?'primary' :''" class="order-quert-retuen-item" @click="changebtn(25)">{{$t('problemorder.tap_courier_loss')}}({{packetlossCount}})</el-button>
				   	<el-button :type="isIndex=== 26 ?'primary' :''" class="order-quert-retuen-item" @click="changebtn(26)">{{$t('problemorder.tap_delivery_timeout')}}({{deliverytimeoutCount}})</el-button>
				   	<el-button :type="isIndex=== 27 ?'primary' :''" class="order-quert-retuen-item" @click="changebtn(27)">{{$t('problemorder.tap_pay_timeout')}}({{paytimeoutCountL}})</el-button>
				   	<el-button :type="isIndex=== 28 ?'primary' :''" class="order-quert-retuen-item" @click="changebtn(28)">{{$t('problemorder.tap_seller_cancel')}}({{buyercanceledCount}})</el-button>
				   	<el-button :type="isIndex=== 29 ?'primary' :''" class="order-quert-retuen-item" @click="changebtn(29)">{{$t('problemorder.tap_others')}}({{otherCount}})</el-button>
				   </div>
				   
				   <div class="order-quert-retuen" v-if="type === 10">
				   	<el-button :type="isIndex=== 11 ?'primary' :''" class="order-quert-retuen-item" @click="donePrint(11)">{{$t('problemorder.tap_ordered')}}</el-button>
				   	<el-button :type="isIndex=== 12 ?'primary' :''" class="order-quert-retuen-item" @click="donePrint(12)">{{$t('problemorder.tap_nerver_order')}}</el-button>
				   </div>
				   <div >
					 <!-- 订单区域 -->
				   	<div class="nodata" v-if="!orderlist.length && !returnList.length" >--{{$t('problemorder.nodata')}}--</div>
				   	<div class="order-wrapper" v-else>
				   		<div class="order-list-item" v-for="(item,index) in orderlist">
				   			<div class="list-desc">
				   				<span v-if="item.reason" class="seller">{{$t('problemorder.return_trickNO')}}：{{item.trackingNumber ? item.trackingNumber : $t('problemorder.no')}}</span>
				   				<span  class="seller">{{$t('problemorder.original_order')}}：{{item.ordersn}}</span>
								<span v-if="item.reason"  class="seller">{{$t('problemorder.return_order')}}：{{item.returnsn}}</span>
				   				<span v-if="item.orderStatus"  class="seller">{{$t('problemorder.order_status')}}：{{getStatus(item)}}</span>
				   				<span v-if="item.reason" class="seller">{{$t('problemorder.order_status')}}：{{getStatus(item)}}</span>
				   				<span v-if="item.orderStatus" class="seller">{{$t('problemorder.cancel_time')}}：{{getTime(item.updateTime)}}</span>
				   				<span v-if="item.orderStatus" class="seller">{{$t('problemorder.print_time')}}：{{getTime(item.printfTime)}}</span>
				   			</div>
				   			<div class="return-desc">
				   				<div class="return-item" >
				   					<!-- 如果查询出来的订单是取消类型的订单，显示 -->
				   					<div v-if="item.orderStatus" class="return-wrpaer">
				   						<div class="return-item-list" v-for="(product,index) in item.items">
				   							<span class="pic-box" ><img v-image-preview :src="changeImgURL(product.image)"  /></span>
				   							<div class="pic-box-desc">
				   								<div class="pic-box-desc-item">{{product.itemName}}</div>
				   								<div class="pic-box-desc-amount"><span class="pic-box-desc-amount-item">{{$t('problemorder.quantity')}}： x{{product.variationQuantityPurchased}}</span><span class="pic-box-desc-amount-item">{{$t('problemorder.price')}}：{{product.variationOriginalPrice}}({{item.currency}}) </span></div>
				   							</div>
				   						</div>
				   					</div>
				   					<!-- 如果查询出来的订单是退货类型的订单，显示 -->
				   					<div v-if="item.reason" class="return-wrpaer">
				   						<div class="return-item-list" v-for="(product,index) in item.items">
				   							<span class="pic-box" ><img v-image-preview :src="changUrl(product.images)"  /></span>
				   							<div class="pic-box-desc">
				   								<div class="pic-box-desc-item">{{product.name}}</div>
				   								<div class="pic-box-desc-amount"><span class="pic-box-desc-amount-item">{{$t('problemorder.return_quantity')}}： x{{product.amount}}</span><span class="pic-box-desc-amount-item">{{$t('other.a831')}}： {{product.itemPrice}}({{item.currency}})</span></div>
				   							</div>
				   						</div>
				   					</div>
				   					
				   					<div class="retrun-reasonr ban">
				   						<div v-if="item.orderStatus">{{$t('problemorder.cancel_reason')}}：{{getCancelByreason(item.cancelReason)}}</div>
				   						<div v-if="item.orderStatus">{{$t('problemorder.shop')}}：{{item.shop.shopName}}</div>
				   						<div v-if="item.orderStatus">{{$t('problemorder.receipent')}}：{{item.recipientAddress ? item.recipientAddress.name : ''}}</div>
				   						<div v-if="item.orderStatus">{{$t('problemorder.phone')}}：{{item.recipientAddress ? item.recipientAddress.phone : ''}}</div>
				   						<div v-if="item.reason">{{$t('problemorder.return_reason')}}：{{getCancelByreason(item.reason)}}</div>
				   						<div v-if="item.reason">{{$t('problemorder.seller_name')}}：{{item.username}}</div>
				   						<div v-if="item.reason">{{$t('problemorder.seller_Email')}}：{{item.email}}</div>
				   						<div v-if="item.reason" class="return-reasonr-desc">{{$t('problemorder.deliver_store')}}：<span>{{deliveryStore(item.storeId)}}</span></div>
				   					</div>
				   					
				   					
				   					<div class="retrun-reasonr  ban">
				   						<div v-if="item.orderStatus">{{$t('problemorder.delivery_method')}}：{{item.shippingCarrier}}</div>
				   						<div v-if="item.orderStatus">{{$t('problemorder.actuall_pay')}}：{{item.totalAmount}}</div>
				   						<div v-if="item.orderStatus">{{$t('problemorder.trickNO')}}：{{item.trackingNo}}</div>
				   						<div v-if="item.orderStatus" class="return-reasonr-desc">{{$t('problemorder.deliver_store')}}：<span>{{deliveryStore(item.storeId)}}</span></div>
				   						<div v-if="item.reason">{{$t('problemorder.return_count')}}：{{item.refundAmount}}({{item.currency}})</div>
				   						<div v-if="item.reason">{{$t('problemorder.origin_prick')}}：{{item.amountBeforeDiscount}}({{item.currency}})</div>
				   						<div v-if="item.reason">{{$t('problemorder.buyer_delivery_deadline')}}：{{handle(item.returnShipDueDate)}}</div>
				   						<div v-if="item.reason">{{$t('problemorder.seller_processing_return_due')}}：{{handle(item.returnSellerDueDate)}}</div>
				   					</div>
				   					
				   					
				   					<div class="retrun-reasonr-btn" >
				   						<el-button style="width:120px; margin:0 0 5px 10px;" type="primary" @click="viewLogistics01(item)">{{$t('problemorder.view_logistics')}}</el-button>
				   						<!-- <el-button style="width:120px; margin:0 0 5px 10px;" type="primary"  @click="handlereturnbag(item)">{{$t('problemorder.return_package')}}</el-button> -->
				   						<el-button style="width:120px" type="danger" v-if="type === 30" @click="sellerComfirm01(item)">{{$t('problemorder.confirmed_by_seller')}}</el-button>
				   						<el-button style="width:120px" type="danger" v-if="type === 31  && userPos === 'STORE'" @click="storeComfirm01(item)">{{$t('problemorder.be_processed_by_store')}}</el-button>
				   					<el-button style="width:120px" type="danger" v-if="type === 31  && userPos === 'SELLER'" @click="sellerComfirm02(item)">{{$t('problemorder.be_processed_by_store')}}</el-button>
				   						
				   						
				   					</div>
				   				</div>
				   				
				   			</div>
				   		</div>
				   	</div>
				   </div> 
				   
				   <!-- 分页器 -->
				   <div class="Pager">
				       <el-pagination
				         @size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage1"
						:page-sizes="[15, 20, 30, 50]"
						:page-size="15"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalCount">
				       </el-pagination>
				     </div>
			   </el-tab-pane>
			     <el-tab-pane label="lazada" name="second">
					 <div>
					 	<el-button size="mini"  class="query-order-item"   @click="changebtn(10)">{{$t('other.a832')}}</el-button>
						<el-button size="mini"  class="query-order-item"   @click="changebtn(11)">{{$t('other.a115')}}</el-button>
						<el-button size="mini"  class="query-order-item"   @click="changebtn(12)">{{$t('other.a833')}}</el-button>
						<!-- 分页器 -->
						<div class="Pager">
						    <el-pagination
						      @size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage1"
							:page-sizes="[15, 20, 30, 50]"
							:page-size="offset"
							layout=" total,sizes, prev, pager, next, jumper"
							:total="isShopee ? totalCount : problemOrderTotal">
						    </el-pagination>
						  </div>
					 </div>
					
					 <div >
					 	<div class="nodata" v-if="!problemOrderList.length" >--{{$t('pendingorder.nodata')}}--</div>
					 	<div class="order-wrapper" v-else>
					 		
					 			<div class="order-list-item" v-for="(item,index) in problemOrderList">
					 				<div class="list-desc">
					 					<!-- <el-checkbox class="chekbox" v-if="checkBox" v-model="item.checked"  @change="getOrderItem(item)"></el-checkbox> -->
					 					<span class="seller">{{$t('pendingorder.orderSn')}}：{{item.orderNumber}}</span>
					 					<span class="seller seller-item">{{$t('pendingorder.status')}}：<span class="seller-ppc">{{item.orderStatus}}</span></span>
					 					<span class="seller seller-item">{{$t('other.a588')}}：<span class="seller-ppc">{{item.createdAt}}</span></span>
					 					<span class="seller seller-item">{{$t('other.a834')}}：<span class="seller-ppc">{{item.price}}</span></span>
					 					<!-- <span class="seller">系统自动取消时间：{{cancelOrderTime(item.payTime,item.daysToShip)}}</span> -->
					 					
					 				</div>
					 				
					 				<div class="return-desc">
					 					<div class="return-item" >
					 						<div class="return-wrpaer">
					 							<div class="return-item-list" v-for="ttp in item.items">
					 								<div class="img-box">
					 									<span class="pic-box" ><img v-image-preview :src="ttp.productMainImage"  /></span>
					 									<div class="pic-box-desc">
					 										<div class="pic-box-desc-item">{{ttp.name}}</div>
					 										<div class="pic-box-desc-amount"><span class="pic-box-desc-amount-item">{{$t('pendingorder.sku')}}： {{ttp.sku}}</span></div>
					 										<!-- <div class="pic-box-desc-amount"><span class="pic-box-desc-amount-item">{{$t('pendingorder.quantity')}}： x{{ttp.variationQuantityPurchased}}</span></div> -->
					 									</div>
					 								</div>
					 								<div >
					 									<div class="return-reasonr-desc">{{$t('other.a156')}}{{ttp.paidPrice}}({{ttp.currency}})</div>
					 									<div class="return-reasonr-desc">{{$t('other.a835')}}：{{ttp.reason}}</div>
					 									<div class="return-reasonr-desc">{{$t('other.a836')}}：{{ttp.shippingType}}</div>
					 						
					 								</div>
					 								<div >
					 									<div class="return-reasonr-desc">{{$t('other.a86')}}{{ttp.trackingCode}}</div>
					 									<div class="return-reasonr-desc">{{$t('other.a837')}}：{{ttp.warehouseCode}}</div>
					 									<div class="return-reasonr-desc">{{$t('other.a68')}}：{{ttp.orderItemId}}</div>
					 								
					 								</div>
					 							</div>
					 						</div>
					 						<div>
					 							<div class="return-reasonr-desc">{{$t('other.a838')}}：{{item.shop.name}}</div>
					 							<div class="return-reasonr-desc">{{$t('other.a838')}}ID：{{item.shop.sellerId}}</div>
					 						</div>
					 						
					 						<!-- <div class="retrun-reasonr-btn" >
					 							<el-button type="primary" @click="saveItem(item.ordersn,item.shop.shopId)">{{$t('pendingorder.review')}}</el-button>
					 						</div> -->
					 					</div>
					 					
					 				</div>
					 			</div>
					 		
					 
					 	</div>
					 	<!-- 分页器 -->
					 	<div class="Pager">
					 	    <el-pagination
					 	      @size-change="handleSizeChange"
					 		@current-change="handleCurrentChange"
					 		:current-page="currentPage1"
					 		:page-sizes="[15, 20, 30, 50]"
					 		:page-size="offset"
					 		layout=" total,sizes, prev, pager, next, jumper"
					 		:total="isShopee ? totalCount : problemOrderTotal">
					 	    </el-pagination>
					 	  </div>
					 </div>
				 </el-tab-pane>
			</el-tabs>
			
		</div>
	</div>
</template>

<script>

import loading from '../../../components/loading.vue'
import utils from '../../../utils/utils.js'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				warehouselist:[],
				options: [{
				          value: 'all',
				          label: this.$t("other.a839")
				        }, {
				          value: 'CANCELLED',
				          label: this.$t("other.a840")
				        }, {
				          value: 'TO_RETURN',
				          label: this.$t("other.a841")
				        },
						{
						  value: 'IN_CANCEL',
						  label: this.$t("other.a842")
						}
						],
				shopeeId: [{
				          value: ' ',
				          label: this.$t("other.a843")
				        }
					],	
					allstore:[
						{
							value:'',
							label:this.$t('shippedorder.all_store')
						}
					],	
					store:'',
				shopeeIdvlue:' ',
				warehouseValue:'',
				value: '',
				queryDate: '',
				shopId:'',
				currentPage1: 1,
				dialogVisible: false,
				shopList: JSON.parse(localStorage.getItem('shopId')),
				start_time:'',
				end_time:'',
				dialogVisible01: false,
				orderSn:'',
				orderShopid:'',
				batchReview:[],
				value1: true,
				value2: true,
				labelCCP:false,
				isReview:false,
				input10:'',
				radio7: '1',
				showbox:'1',
				ttp:true,
				pagesize:15,
				currentPage:0, //当前页码
				offset:15, //每页显示条数
				type:13,
				returnOrder:false,
				dialogVisible_returnorder:false,
				return_desc_order:[],
				LogisticsWindow:false,  
				textarea:'',
				returnInfo:false,
				returnStur:'',
				isIndex:0,
				radio2:0,
				sellerOperaList:[],
				shangjianNum:0,
				returnInfo88:false,
				returnItem:null,
				activeName:'first',
				isShopee:true,
				returnbag:false,
				returnImag:[],
				sellerReturnNum:0,
				viewReturnDescData:''
				
				
	};
		},
		components:{
			loading
		},
		inject:['reload'],
		watch:{
			input10(){
				if(this.input10 === ""){
					this.handleCurrentChange()
				}
				
			}
		},
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				orderlist: state => state.order.ax_quesetionOrderList,
				warehouse: state => state.shopaccess.warehouse,
				isSuccess: state => state.order.isSuccess,
				list: state => state.order.quesetionOrderList,
				problemorderCounts: state => state.order.problemorderCounts,
				returnorderCounts: state => state.order.returnorderCounts,
				inCancelCounts: state => state.order.inCancelCounts,
				returnList:state => state.order.returnList,
				applicationCounts:state => state.order.applicationCounts,
				rulingCounts:state => state.order.rulingCounts,
				acceptedCounts:state => state.order.acceptedCounts,
				cancelCounts:state => state.order.cancelCounts,
				returnCounts:state => state.order.returnCounts,
				disputeCounts:state => state.order.disputeCounts,
				returnedCounts:state => state.order.returnedCounts,
				closedCounts:state => state.order.closedCounts,
				verifiedCounts:state => state.order.verifiedCounts,
				deliverfailedCount:state => state.order.deliverfailedCount,
				packetlossCount:state => state.order.packetlossCount,
				deliverytimeoutCount:state => state.order.deliverytimeoutCount,
				paytimeoutCountL:state => state.order.paytimeoutCountL,
				buyercanceledCount:state => state.order.buyercanceledCount,
				otherCount:state => state.order.otherCount,
				LogisticsInfo: state => state.order.LogisticsInfo,
				userPos: state=>state.login.userInfo.userPos || '',
				management01:state => state.order.management01,
				management02:state => state.order.management02,
				management03:state => state.order.management03,
				problemOrderList: state => state.lazadaorders.problemOrderList,
				problemOrderTotal: state => state.lazadaorders.problemOrderTotal,
				tuhuodingdang:state => state.order.tuhuodingdang,
				canceldingdang:state => state.order.canceldingdang,
				senqingquxiao:state => state.order.senqingquxiao,
				
				
			}),
			
			coustomer(){
				return this.orderlist.items
			},
		    totalCount(){
				if(this.type === 14) {
					return this.tuhuodingdang
				}else if(this.type === 13) {
					return this.canceldingdang
				}else if(this.type === 10) {
					return this.senqingquxiao
				}else if(this.type === 130) {
					return this.returnorderCounts
				}else if(this.type === 19) {
					return this.returnCounts
				}else if(this.type === 20) {
					return this.returnCounts
				}else if(this.type === 15) {
					return this.applicationCounts
				}else if(this.type === 16) {
					return this.acceptedCounts
				}else if(this.type === 17) {
					return this.cancelCounts
				}else if(this.type === 18) {
					return this.rulingCounts
				}else if(this.type === 21) {
					return this.closedCounts
				}else if(this.type === 22) {
					return this.returnedCounts
				}else if(this.type === 23) {
					return this.disputeCounts
				}else if(this.type === 24) {
					return this.deliverfailedCount
				}else if(this.type === 25) {
					return this.packetlossCount
				}else if(this.type === 26) {
					return this.deliverytimeoutCount
				}else if(this.type === 27) {
					return this.paytimeoutCountL
				}else if(this.type === 28) {
					return this.buyercanceledCount
				}else if(this.type === 29) {
					return this.otherCount
				}else if(this.type === 31) {
					return this.management02
				}else if(this.type === 32) {
					return this.management03
				}
			}
			
			
		},
		created(){
		
		this.init()
		},
		methods: {
			...mapActions('order', [
				'getProblemorder',
				'getOrdersBytrickNo',
				'viewLogistics',
				'sellerComfirm',
				'storeComfirm',
				'getOrdersBytrickNo_return',
				'getOrderCountTotal'
				
			]),
			...mapActions('lazadaorders', [
				'getLazadaOrderByuserid'
				
			]),
			...mapMutations('order', [
				'SET_ORDER_FINISH',
				'SET_ORDER_UNPAID',
				'READY_TO_SHIP',
				'QUESTION_ORDER_CHOOSE',
				'CANCELLED',
				'TO_RETURN',
				'TO_CONFIRM_RECEIVE',
				'SET_ORDERLIST_NULL',
				'GET_UNPROCESS_ORDER',
				'CHOOSE_SHOPID',
				'GO_TO_SEARCH_PENDING',
				'SUCCESS_GET_DATA_OPEN',
				'GO_TO_SEARCH_QUESTION',
				'GET_STORE_ALERDAY_PRINT'
				
			]),
			
			handle(date){
				let ttp=utils.renderTime(date)
				return ttp
			},
			StoreComfirm(){
				this.returnStur.items.forEach(p => {
					p.storeReturnNum=p.sellerReturnNum
					p.storeReturnType=p.sellerReturnType
				})
				this.returnStur.storeAudit=1
				this.returnStur.storeMessage=this.textarea
				console.log(this.returnStur)
				this.storeComfirm(this.returnStur)
				setTimeout(()=> {
					this.reload()
				},1000)
			},
			returnCause(ttp) {
				const status = {
					'LOST_PARCEL': this.$t("other.a114"),
					'LOGISTICS_DELIVERY_FAILED': this.$t("other.a115"),
					'Failed Delivery':this.$t("other.a115"),
					'LOST_PARCEL':this.$t("other.a114"),
					'Parcel lost in transit. The eligible compensation has been credited into your seller wallet.':this.$t("other.a114"),
					'LOGISTICS_ISSUE':this.$t("other.a139"),
					'Logistic Issue':this.$t("other.a139"),
					'Delivery service provider reported that the parcel has been lost.':this.$t("other.a114"),
					'FRAUD_CASE':'FRAUD_CASE',
					'':this.$t("other.a140"),
					
					
					
				}
				return status[ttp]
			},
			handlereturnbag(item){
				this.viewReturnDescData=item
				this.returnbag=true
				console.log(item)
				this.returnImag=item.returnOrderImages
				console.log('退货详情',this.viewReturnDescData)
			},
			handleClick(tap) {
			   console.log(tap.label)
			   if(tap.label === "shopee" ){
				   this.isShopee=true
				 this.changebtn(30)
			   }else if(tap.label === "lazada"){
				   this.isShopee=false
				   this.changebtn(9)
				
			  }
			},
			storeComfirm01(item){
				this.returnInfo=true
				this.returnStur=item
			},
			checkReturn(item){
				console.log(item)
				this.returnItem=item
				this.returnInfo88=true
			},
			init(){
				if(this.userPos === "STORE") {
					this.changebtn_STORE(30)
				}else if(this.userPos === "SELLER"){
					let shopId=JSON.parse(localStorage.getItem('shopIdInfo'))
					let ttp=shopId.map(item => {
						return {
							value: item.shopId,
							label: item.shopName,
						}
					})
					let mmp=this.warehouse.map(item => {
						return {
							value:item.storeId,
							label:item.storeName
						}
					})
					ttp.forEach(p => {
						this.shopeeId.push(p)
					})
					
					mmp.forEach(s => {
						this.warehouselist.push(s)
					})
					this.shopeeIdvlue=this.shopeeId[1].value 
				
					this.changebtn(13)
				}
			},
			returnGoods(){
				console.log(this.textarea)
				console.log(this.store)
				if(!this.store) {
					this.$message({
						message:this.$t("other.a844"),
						type:'error'
					})
					return
				}
				
				this.returnItem.returnStore=this.store
				this.returnItem.returnMessage=this.textarea
				
			
				console.log('确认收货信息',this.returnItem)
				this.returnInfo88=false
			},
			
			comfirm(item){
				this.returnStur.sellerAudit=1
				this.returnStur.sellerMessage=this.textarea
				this.returnStur.sellerReturnNum=this.sellerReturnNum
				console.log(this.returnStur)
				let ttp=false
				this.returnStur.items.forEach(p => {
					if(p.sellerReturnType === 2 && p.sellerReturnNum ==0 ) {
					   ttp=true
					}
				})
				
				if(ttp) {
					this.$message.error(this.$t("other.a845"))
					return
				}else {
					this.sellerComfirm(this.returnStur)
					this.returnInfo=false
					this.radio2=0
				}
				
				
				
			},
			sellerComfirm01(item){
				
				if(this.userPos === "STORE") {
					this.$message.success(this.$t("other.a846"))
					return
				}
				this.returnStur=item
				this.returnInfo=true
				console.log(item)
			},
			sellerComfirm02(item){
				
				if(this.userPos === "SELLER") {
					this.$message.success(this.$t("other.a847"))
					return
				}
				this.returnStur=item
				this.returnInfo=true
				console.log(item)
			},
			
			viewLogistics01(item) {
				this.viewLogistics(item)
				this.LogisticsWindow=true
				
			},
			deliveryStore(num){
				if(num==null){
					return this.$t("other.a848")
				}
				let ttp=null
				this.warehouse.forEach(item => {
					if(item.storeId === num ) {
						ttp=item
					}else{
						ttp =item
					}
				})
				
				return ttp.storeName + '(' + ttp.userName + ")"
				
			},

			saveItem(ttp,ccp){
				this.dialogVisible01=true
				this.orderSn=ttp
				this.orderShopid=ccp
			},
			getTime(time){
				if(!time) {
					return this.$t("other.a354")
				}
				let ttp=time.slice(0,time.indexOf('T'))
				let ccp=time.slice(time.indexOf('T')+1,time.indexOf('.'))
				return ttp+ ' ' + ccp
			},
			getStatus(item){
				let ttp=utils.conversionStatus(item)
				return ttp
			},
			setNowTimes (atp){
				let myDate = atp
				    // console.log(myDate)
				    let wk = myDate.getDay()
				    let yy = String(myDate.getFullYear())
				    let mmp = myDate.getMonth() + 1
					let mm = String(mmp < 10 ? '0' + mmp : mmp) 
				    let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
				    let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
				    let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
				    let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
				    let weeks = [this.$t("chat.Sunday"), this.$t("chat.Monday"), this.$t("chat.Tuesday"), this.$t("chat.Wednesday"), this.$t("chat.Thursday"), this.$t("chat.Friday"), this.$t("chat.Saturday")]
				    let week = weeks[wk]
				    let nowDate = yy + '-' + mm + '-' + dd
				    let nowTime = hou + ':' + min + ':' + sec
				    let nowWeek = week
				    let ccp = nowDate + ' ' + nowTime + ' ' + nowWeek
					return  ccp.substring(0,11)
			},
			
			chooseOrder(numn){
				this.SUCCESS_GET_DATA_OPEN()
			
				let start=this.setNowTimes(this.queryDate[0])
				let end=this.setNowTimes(this.queryDate[1])
				
				const params={
					userId: this.userId,
					start: start,
					end: end,
				}
				
				
				this.SET_ORDERLIST_NULL()
				// this.getunprocessOrder(params)
				
				
			},
			getLocalTime(tiem) {
				//将时间戳（十三位时间搓，也就是带毫秒的时间搓）转换成时间格式
				// d.cTime = 1539083829787
				let  ttp=parseInt(tiem) * 1000
				let date = new Date(ttp);
			    let Y = date.getFullYear() + '-';
				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				let D = date.getDate() + ' ';
				let h = date.getHours() + ':';
				let m = date.getMinutes() + ':';
				let s = date.getSeconds();
				return Y + M + D + h + m + s;
			
				console.log(date)
			},
			//订单筛选
			choice(num) {
				console.log(num)
				this.QUESTION_ORDER_CHOOSE(num)
			},
			choiceshopId () {
				console.log(this.shopeeIdvlue)
				this.CHOOSE_SHOPID(this.shopeeIdvlue)
	
			},
			accp(){
				console.log(this.returnList)
				console.log(this.orderlist)
				console.log(this.deliverfailedCount)
				
			},
			auditType(num){
				console.log(num)
				const ttp={
					1:this.$t('other.a805'),
					2:this.$t('other.a806'),
					3:this.$t('other.a807')
				}
				console.log(ttp[num])
				return ttp[num]
			},
			 changeImgURL(url){
				
				 if(url === ' ') {
					 return
				 }else{
					 let baseUrl="https://s-cf-th.shopeesz.com/"
					 let index=url.indexOf("/file/")
					 let ttp=url.slice(index)
					 return baseUrl+ttp
				 }
				
				
			 },
			
			
			 gotosearch(){
				const params={
					orders:this.input10,
					type:9
				}
			 	this.getOrdersBytrickNo(params)
				
			 },
			 gotosearch01(){
			 				const params={
			 					orders:this.input10,
			 					type:9
			 				}
			 	this.getOrdersBytrickNo_return(params)
			 				
			 },
			 changebtn_STORE(num){
				 this.isIndex=num
				 this.type=num
				 const params={
				 	offset:this.offset,
				 	page:this.currentPage,
				 	userId:this.userId,
				 	type:this.type,
				 	shopId:JSON.parse(localStorage.getItem('userInfo')).shopIds,
				 }
				  this.getProblemorder(params)
			 },
			 //获取退货管理 已取消,退货,申请取消的订单
			 changebtn(num){
				 if(this.isShopee) {
					 console.log(this.shopeeIdvlue)
					if(num){
						this.isIndex=num
						this.type=num
					}
					 const params={
					 	offset:this.offset,
					 	page:this.currentPage,
					 	userId:this.userId,
					 	type:this.type,
						sortType:1,
					 	shopId:this.shopeeIdvlue
					 }
					 console.log(params)
					 this.getProblemorder(params)
				 }else{
					 this.type=num
					 const params={
					 	offset:this.offset,
					 	page:this.currentPage,
					 	userId:this.userId,
					 	type:this.type,
					 	shopId:this.shopeeIdvlue
					 }
					 
					 this.getLazadaOrderByuserid(params)
				 }
				
				
		
			 },
			 changebtn01(){			
				 const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					type:this.type,
					shopId:this.shopeeIdvlue
				 }
				 console.log(params)
				 this.getProblemorder(params)
			
			 		
			 },

			 
			 cancel(n){
				 const ttp={
					 buyer:this.$t("other.a849"),
					 system:this.$t("other.a850"),
				 }
				 
				 return ttp[n]
			 },
			 getCancelByreason(n){
				 const ttp={
					 "Seller is not responsive to my inquiries":this.$t("other.a851"),
					 "SYSTEM_UNPAID" : this.$t("other.a852"),
					 "Others / change of mind" : this.$t("other.a853"),
					 "LOST_PARCEL" : this.$t("other.a854"),
					 "BACKEND_SELLER_DID_NOT_SHIP":this.$t("other.a855"),
					 "UNDELIVERABLE_AREA":this.$t("other.a856"),
					 "BACKEND_LOGISTICS_NOT_STARTED":"BACKEND_LOGISTICS_NOT_STARTED",
					 "LOGISTICS_PICKUP_FAILED":"LOGISTICS_PICKUP_FAILED",
					 "LOGISTICS_DELIVERY_FAILED":"LOGISTICS_DELIVERY_FAILED",
					 "Modify existing order (colour, size, address, voucher, etc.)":"Modify existing order (colour, size, address, voucher, etc.)",
					 "PHYSICAL_DMG":this.$t("other.a857"),
					 "FUNCTIONAL_DMG":this.$t("other.a858"),
					 "WRONG_ITEM":this.$t("other.a859"),
					 "NOT_RECEIPT":this.$t("other.a860")
				 }
				if(!n){
					return this.$t("other.a354")
				}else{
					return ttp[n]
				}
				 
				 
			 },
			 //控制每页显示订单条数
			 handleSizeChange(val) {
			 				 console.log(`每页 ${val} 条`);
			 				 this.offset=parseInt(`${val}`)
			 				 this.handleCurrentChange()
			   },
			   //显示当前第几页
			   handleCurrentChange(val) {
				  
			 				 this.currentPage=(parseInt(`${val}`) -1) * this.offset
			 				const params={
			 					offset:this.offset,
			 					page:this.currentPage,
			 					userId:this.userId,
			 					type:this.type,
			 					shopId:this.shopeeIdvlue
			 				}
			 				 console.log(params)
							 if(this.isShopee) {
							 	 this.getProblemorder(params)	   
							 }else{
								 this.getLazadaOrderByuserid(params)
							 }
			 				
			   },
			   changUrl(url) {
				   let ccp =JSON.parse(url)
				   let imgUrl=ccp[0]
				 
				  let baseUrl="https://s-cf-th.shopeesz.com/"
				  let index=imgUrl.indexOf("/file/")
				  let ttp=imgUrl.slice(index)
				  return baseUrl+ttp
			   },
			
			   viewMore(item){
				    this.return_desc_order=[]
				   this.dialogVisible_returnorder=true
				   this.return_desc_order.push(item)
			   },
			   orderReturndesc(url){
				    let ccp =JSON.parse(url)
					return ccp
			   },
			
			  
			
			 
		}
	}
</script>

<style>
	.problemorder {
		flex: 1;
		margin: 60px 0 0 235px;
	}

	.problemorder .order-list-item {
		position: relative;
		padding-bottom: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

	.problemorder .order-title{
		
	
		padding: 5px;
		border-bottom: 1px #E0E0E0 solid;
	}
	.problemorder .order-query {
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
		padding: 10px 0;
		border-bottom: 1px #E0E0E0 solid;
	}
	

	.problemorder .order-query .query {
		position: relative;
		margin-right: 30px;
		;
	}

	.problemorder .list-btn {
		padding: 20px 15px;
	}
    .problemorder .order-title-count{
		color: red;
		font-size: 12px;
		font-style: inherit;
		margin-left: 10px;
	}
	.problemorder .list-desc {
		margin-left: 15px;
		border-bottom: 1px #eee solid;
	}

	.problemorder .list-desc-item {
		font-size: 14px;

		padding-right: 15px;
	}

	.problemorder .list-item-status {
		color: red;
	}

	.problemorder .didan {
		font-size: 24px;
	}

	.problemorder .list-content {
		display: flex;
		justify-content: space-around;
		/* margin: 20px;
	padding: 20px; */
		/* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
	}

	.problemorder .order-pic {
		width: 80px;
		height: 80px;
	}

	img {
		width: 100%;
		height: 100%;
	}

	.problemorder .list-content-left,
	.list-content-right {
		display: flex;
		
	}
	.problemorder .commitRevies{
		margin-left: 40px;
	}

	.problemorder .list-item-wrapper {
		box-sizing: border-box;
		padding: 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}
	.problemorder .order-selec{
		width: 150px;
		margin: 0 10px;
	}
	.problemorder .order-desc{
		width: 30%;

	}
	
	.problemorder .order-title-desc{
		margin-bottom: 15px;
	}
	.problemorder .list-price-item,.shoper-name{
		padding: 2px 0;
	}
	.problemorder .list-number,.list-price{
		margin-left: 40px;
	}
	.problemorder .primary-btn-ttp{
		display: inline-block;
		margin: 0 30px;
	}
	
/* 	.loading{
		position: absolute;
		right: 0;
		top: 180px;
		width: 80%;
		
	} */
	
	.problemorder .search-box{
		width: 60px;
	}
	
	.problemorder .nodata{
		margin-top: 100px;
		text-align: center;
		color: #000;
	}
	
	.problemorder .chekbox{
		width: 30px;
		height: 30px;
		
	}
	
	.problemorder .second-menu{
		display: flex;
		justify-content: space-between;
	}
	.problemorder .menu-right-btn{
		margin-right: 30px;
	}
	.problemorder .second-menu-left{
		flex: 1;
		display: flex;;
		align-items: center;
		
	}
	
	.problemorder .search-box{
		width: 100px;
		margin: 0 10px 0px 10px;
	}
	.problemorder .order-wrapper{
		margin-top: 10px;
	}
	
	.problemorder .sousuo-box{
		width: 300px;
	}
	
	.problemorder .circle-box{
		position: relative;
		border-bottom: 1px solid #EEEEEE;
		padding-bottom: 5px;
		margin-bottom: 5px;
	}
	
		.problemorder .circle{
		position: absolute;
		top: 0;
		left: 0;
		border-radius: 50%;
			width: 25px;
			height: 25px; 
			background-color: red;
	}
	
	.problemorder .cricle-num{
		padding-left:5px;

	}
	
	.problemorder .circle-box-one{
		height: 30px;
		line-height: 30px;
		
	}
	
	.problemorder .cancelreason{
		padding: 10px;
		color: #409EFF;
		cursor: pointer;
	}
	
	
    .problemorder .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	.problemorder .order-quert-retuen{
		display: flex;
		margin-bottom: 10px;
	}
	.problemorder .order-quert-retuen-item{
		box-sizing: border-box;
		padding: 10px;
		cursor: pointer;
	}
	
	.problemorder .query-order-item{
		font-size: 14px;
	
	}
	.problemorder .seller-img{
		display: inline-block;
		width: 50px;
		height: 50px;
	
	}
	.problemorder .seller{
		display: inline-block;
		margin: 5px 10px;
	}

	
	.problemorder .pic-box{
	 display:inline-block;
	 width: 100px;
	 height: 100px;
	}
	.problemorder .return-item{
		display: flex;
		justify-content: space-between;
	}
	.problemorder .return-item-list{
		display: flex;
		box-sizing: border-box;
		padding: 10px 10px 10px 15px;
	}
	.problemorder .pic-box-desc{
		width: 230px;
		padding-left: 10px;
	}
	.problemorder .pic-box-desc-amount{
		margin-top: 10px;
		color: red;
	}
	.problemorder .return-btn-item-oop{
		margin-left: 0 !important;
		margin-bottom: 10px;
	}
	
	.problemorder .retrun-reasonr-btn{
		display: flex;
		width: 150px;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-right: 30px;
	}
	
	.problemorder .retrun-reasonr{
		
		box-sizing: border-box;
		padding: 10px;
	
	}
	
	.problemorder .pic-box-desc-amount-item{
		display: inline-block;
		margin-left: 10px;
	}	
	.problemorder .retrun-btn{
	display: flex;
	flex-direction: column;
	align-items: center;
	box-sizing: border-box;
	padding: 20px;
		
	}
	.problemorder .return_desc{

		width: 500px;
		height: 500px;
		border: 1px solid #000000;
		overflow: hidden;
		  margin-left: 25px;
	}
	.problemorder .return-desc-pic-box{
		display: flex;
	    margin: 2px;
		width: 80px;
		height: 80px;
	}
	
    .vue-directive-image-previewer{
		z-index: 9999 !important;
	}
	.problemorder .return-desc-pic-item{
		display: flex;
		flex-wrap: wrap;
	
		  
	
	}
	
	.problemorder .return_desc_item{
		display: flex;
		box-sizing: border-box;
		padding: 10px 5px;
		border-bottom: 1px solid #EEEEEE;
		
	}

	.problemorder .price{
		background-color: red;
		color: #FFFFFF;
		height: 50px;
		
		font-size: 20px;
	}
	
	.problemorder .order{
		display: flex;
		justify-content: space-between;
	}
	
	.problemorder .order-ppo{
		width: 50%;
	}
	
	.problemorder .ban{
		width: 250px;
		overflow: hidden;
	}
	
	.problemorder .sellerMessage{
		color:red;
	
	}
	.problemorder .img-box{
		display: flex;
	}
	
	

	

</style>
